import { combineReducers } from "redux";
import AuthReducer from "./Auth/auth.slice";
import SetupReducer from "./Setup/setup.slice";

const rootReducer = combineReducers({
  auth: AuthReducer,
  setup: SetupReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export { rootReducer };
